/**
 * Majahma Cart — Guided cart logic v5
 * ----------------------------------------------------------------------------
 *  - Diet toggle (Vegetarian / Vegan) swaps the tiffin variant
 *  - Frequency change syncs the tiffin AND every selected side to the matching
 *    Recharge selling plan
 *  - Postcode validation determines which day(s) the area is served
 *  - Calendar shows all valid Thursdays/Fridays as a month grid; non-applicable
 *    dates greyed out. Day is derived from the picked date (no separate chooser).
 *  - "Delivered every <day>" updates the order card live
 *  - Remove from basket clears cart + redirects home
 *  - what3words.com link opens centred on the customer's postcode
 *
 * Delivery zones are defined in the theme editor as Delivery zone blocks on the
 * Majahma Cart Items section. DELIVERY_ZONES below is only the fallback used
 * when no blocks exist or none of them parse.
 *
 * Delivery surcharges are PAUSED: ZONE_SURCHARGES is unused and
 * `delivery_surcharge_pence` is written blank. Per-order delivery charging is
 * being designed separately.
 */

(function () {
  'use strict';

  const DELIVERY_ZONES = [
    {
      days: ['thursday', 'friday'],
      label: 'Brighton & Hove core',
      polys: [
        [[-0.1208139,50.8377469],[-0.1256272,50.8385858],[-0.1298793,50.8348844],[-0.1331872,50.8352483],[-0.1341373,50.84354],[-0.1457415,50.8440309],[-0.1466856,50.8381774],[-0.149132,50.8377152],[-0.1531661,50.8369021],[-0.1543704,50.8378936],[-0.1575487,50.8348198],[-0.1652982,50.8375301],[-0.1706205,50.8232261],[-0.1278357,50.8170523],[-0.1228161,50.8238873],[-0.1177531,50.827362],[-0.1140333,50.8282231],[-0.1116122,50.8327474],[-0.119584,50.8345064],[-0.1190093,50.8354936],[-0.1217851,50.8362085],[-0.1208139,50.8377469]],
        [[-0.2094155,50.8257742],[-0.1939147,50.8253948],[-0.1474561,50.8195629],[-0.1041015,50.8107855],[-0.0938854,50.809106],[-0.0918681,50.8113026],[-0.0601561,50.802107],[-0.0299437,50.7962483],[-0.0170063,50.8083065],[-0.0187229,50.8150315],[-0.047562,50.8130791],[-0.0627311,50.8213059],[-0.0554585,50.8334661],[-0.0576349,50.8381741],[-0.0701125,50.8428816],[-0.0869353,50.840822],[-0.074404,50.8673725],[-0.0852187,50.8748473],[-0.1562865,50.8693226],[-0.2127631,50.8525278],[-0.2071839,50.8465891],[-0.2094155,50.8257742]]
      ]
    },
    {
      days: ['friday'],
      label: 'Worthing & Shoreham',
      polys: [
        [[-0.451458,50.8025633],[-0.3869134,50.8061433],[-0.3340417,50.8170986],[-0.2947312,50.8237139],[-0.2094155,50.8257742],[-0.2070122,50.8372669],[-0.2071839,50.8465891],[-0.2116217,50.8542219],[-0.2327615,50.8594853],[-0.2456361,50.8501657],[-0.2755051,50.847131],[-0.3072625,50.8400854],[-0.3312951,50.843771],[-0.3836518,50.8400854],[-0.3972131,50.8590519],[-0.4092293,50.8513579],[-0.4298287,50.8413862],[-0.4341202,50.8236054],[-0.4624444,50.8220872],[-0.451458,50.8025633]]
      ]
    },
    {
      days: ['friday'],
      label: 'Mid Sussex',
      polys: [
        [[-0.197747,50.9380392],[-0.2698447,50.940419],[-0.2695631,50.939968],[-0.1977173,50.9378425],[-0.197747,50.9380392]],
        [[-0.2701881,50.9399863],[-0.2921607,50.9341448],[-0.2887275,50.9293845],[-0.273278,50.9222431],[-0.261605,50.9272206],[-0.2695631,50.939968],[-0.2701881,50.9399863]],
        [[0.0538394,50.8994809],[0.0269543,50.8781226],[-0.0126155,50.8834053],[-0.0061729,50.8683228],[0.0116341,50.8678828],[0.0675655,50.8925647],[0.0834014,50.9340242],[0.0538394,50.8994809]],
        [[0.0834014,50.9340242],[0.0962092,50.9489718],[0.1145826,50.9581877],[0.1148367,50.9796276],[0.0988608,50.9835913],[0.0780507,50.9750213],[0.0817776,50.9657425],[0.0278251,50.977213],[-0.0705071,51.0009718],[-0.0741508,51.0206109],[-0.1486518,51.0184512],[-0.1448753,51.0061391],[-0.1256492,50.9990095],[-0.1198127,50.9674533],[-0.1582649,50.966156],[-0.1603248,50.9546951],[-0.1421287,50.9434476],[-0.1283958,50.9434476],[-0.1314857,50.9315483],[-0.1500251,50.9382556],[-0.1829841,50.9466924],[-0.1970603,50.9378229],[-0.1977173,50.9378425],[-0.1970603,50.9334957],[-0.1778342,50.9304664],[-0.1610114,50.9239745],[-0.1513984,50.9187802],[-0.1239326,50.9179145],[-0.1143195,50.9109878],[-0.0974967,50.9163994],[-0.1277091,50.9298173],[-0.1204993,50.9449619],[-0.0820472,50.942366],[-0.1143195,50.9799919],[-0.0659111,50.997281],[0.0201302,50.9752597],[0.0888321,50.960108],[0.0902251,50.9518655],[0.0834014,50.9340242]]
      ]
    }
  ];

  // The zones above are the FALLBACK only. The live zones come from the theme
  // editor (Delivery zone blocks on the Majahma Cart Items section) so the
  // delivery area can be changed without touching code — see loadZonesFromTheme.
  let activeZones = DELIVERY_ZONES;

  // ─── DELIVERY SURCHARGES — PAUSED ───────────────────────────────────────
  // Kept for reference only. Nothing reads these and no surcharge attribute is
  // written; per-order delivery charging is being designed separately. To bring
  // them back, re-enable the write in collectAttributes().
  const ZONE_SURCHARGES = {
    'Brighton & Hove core':  300,
    'Worthing & Shoreham':   450,
    'Mid Sussex':            450
  };

  const BLACKOUT_DATES = [
    '2026-12-24',
    '2026-12-25',
    '2026-12-26',
    '2026-12-31',
    '2027-01-01'
  ];

  const THURSDAY = 4;
  const FRIDAY   = 5;
  const CUTOFF_DAY  = 2;
  const CUTOFF_HOUR = 18;
  const WEEKS_AHEAD = 6;

  // ─── LIONWHEEL ───────────────────────────────────────────────────────────
  // Fixed fields the LionWheel route import expects on every order. Verified
  // constant across 2,818 orders in the 12 months to Sep 2026 — one distinct
  // value each, never varying. Change them HERE, not inline, if LionWheel ever
  // reassigns the pickup location or adds a collection option.
  const LIONWHEEL_LOCATION_ID    = '211163';
  const LIONWHEEL_CHECKOUT_METHOD = 'delivery';

  let cartConfig = {
    tiffinProductId: null,
    vegVariantId: null,
    veganVariantId: null,
    weeklyPlanId: null,
    fortnightlyPlanId: null,
    fourWeeklyPlanId: null
  };

  let validatedPostcode = null;
  let allowedDays       = [];
  let selectedDate      = null;
  let currentZoneLabel  = null;

  document.addEventListener('DOMContentLoaded', function () {
    initCartPage();
  });

  function initCartPage() {
    const cartEl = document.getElementById('majahma-cart');
    const form = document.getElementById('majahma-cart-form');
    if (!form) return;

    const themeZones = loadZonesFromTheme();
    if (themeZones) activeZones = themeZones;

    if (cartEl) {
      cartConfig.tiffinProductId = cartEl.getAttribute('data-tiffin-product-id') || null;
      cartConfig.vegVariantId    = cartEl.getAttribute('data-veg-variant-id')    || null;
      cartConfig.veganVariantId  = cartEl.getAttribute('data-vegan-variant-id')  || null;
      cartConfig.weeklyPlanId    = cartEl.getAttribute('data-weekly-plan-id')    || null;
      cartConfig.fortnightlyPlanId = cartEl.getAttribute('data-fortnightly-plan-id') || null;
      cartConfig.fourWeeklyPlanId  = cartEl.getAttribute('data-four-weekly-plan-id')  || null;
    }

    form.querySelectorAll('.majahma-cart__qty-btn').forEach(function (btn) {
      btn.addEventListener('click', handleQtyChange);
    });
    form.querySelectorAll('.majahma-cart__remove').forEach(function (btn) {
      btn.addEventListener('click', handleRemove);
    });

    const checkBtn = document.getElementById('check-postcode-btn');
    if (checkBtn) checkBtn.addEventListener('click', handlePostcodeCheck);

    const postcodeInput = document.getElementById('cart-postcode');
    if (postcodeInput) {
      postcodeInput.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); handlePostcodeCheck(); }
      });
    }

    ['cart-delivery-instructions', 'cart-w3w'].forEach(function (id) {
      const field = document.getElementById(id);
      if (!field) return;
      field.addEventListener('change', autoSaveCartAttributes);
      field.addEventListener('blur', autoSaveCartAttributes);
    });

    // Diet change → swap tiffin variant (works for both radios and <select>)
    form.querySelectorAll('input[name="attributes[diet_preference]"], select[name="attributes[diet_preference]"]').forEach(function (input) {
      input.addEventListener('change', handleDietChange);
    });

    // Frequency change → re-sync all line items
    form.querySelectorAll('input[name="attributes[frequency]"], select[name="attributes[frequency]"]').forEach(function (input) {
      input.addEventListener('change', handleFrequencyChange);
    });

    // Food sensitivities Yes/No → reveal details
    form.querySelectorAll('input[name="attributes[food_sensitivities_answer]"]').forEach(function (input) {
      input.addEventListener('change', handleSensitivitiesAnswerChange);
    });
    handleSensitivitiesAnswerChange();

    // Remove from basket
    var clearBtn = document.getElementById('majahma-clear-cart-btn');
    if (clearBtn) clearBtn.addEventListener('click', handleClearCart);

    // what3words link follows the postcode
    var w3wLink = document.getElementById('cart-w3w-link');
    if (w3wLink && postcodeInput) {
      function updateW3WLink() {
        var pc = postcodeInput.value.trim();
        if (pc) {
          w3wLink.href = 'https://map.what3words.com/?query=' + encodeURIComponent(pc + ', UK');
        } else {
          w3wLink.href = 'https://what3words.com/';
        }
      }
      updateW3WLink();
      postcodeInput.addEventListener('input', updateW3WLink);
      postcodeInput.addEventListener('change', updateW3WLink);
    }

    // Restore postcode validation state on load
    var savedPostcodeVal = postcodeInput && postcodeInput.value.trim();
    var savedDateEl = document.getElementById('cart-delivery-date');
    if (savedPostcodeVal && savedDateEl && savedDateEl.value) {
      var cleaned = savedPostcodeVal.toUpperCase().replace(/\s+/g, '');
      fetch('https://api.postcodes.io/postcodes/' + encodeURIComponent(cleaned))
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data.result) {
            var zone = lookupCoords(data.result.longitude, data.result.latitude);
            if (zone) {
              validatedPostcode = savedPostcodeVal;
              allowedDays = zone.days;
              currentZoneLabel = zone.label;
              showDeliveryStep(zone.days);
              selectedDate = savedDateEl.value;
              highlightSelectedDate(savedDateEl.value);
              updateSelectedDateDisplay(savedDateEl.value);
            }
          }
        })
        .catch(function () {});
    }
  }

  // ─── REMOVE FROM BASKET ─────────────────────────────────────────────────
  function handleClearCart(e) {
    var btn = e.currentTarget;
    if (btn.disabled) return;
    var confirmed = window.confirm('This will empty your basket. Are you sure?');
    if (!confirmed) return;

    btn.disabled = true;
    var originalText = btn.textContent;
    btn.textContent = 'Removing…';

    fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } })
      .then(function () {
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            attributes: {
              delivery_postcode: '',
              delivery_zone: '',
              delivery_surcharge_pence: '',
              delivery_day: '',
              delivery_date: '',
              diet_preference: '',
              frequency: '',
              food_sensitivities_answer: '',
              food_sensitivity_allergens: '',
              food_sensitivities_details: '',
              terms_accepted: ''
            },
            note: ''
          })
        });
      })
      .then(function () { window.location.href = '/'; })
      .catch(function (err) {
        console.error('[Majahma] Clear cart failed:', err);
        btn.disabled = false;
        btn.textContent = originalText;
        window.alert('Could not empty your basket. Please refresh and try again.');
      });
  }

  // ─── DIET TOGGLE ─────────────────────────────────────────────────────────
  function handleDietChange(e) {
    const MS = window.MajahmaSubscriptions;
    const newDiet = e.target.value;
    const statusEl = document.getElementById('diet-status');

    autoSaveCartAttributes();

    const tiffinItem = findTiffinItem();
    if (!tiffinItem) {
      if (statusEl) statusEl.textContent = 'Saved.';
      return;
    }
    if (!MS) {
      if (statusEl) statusEl.textContent = 'Could not update diet because the subscription helper did not load. Please refresh and try again.';
      return;
    }

    const itemKey = tiffinItem.getAttribute('data-key');
    const currentQty = parseInt(tiffinItem.querySelector('.majahma-cart__qty-input').value, 10) || 1;
    const freqInput = document.querySelector('input[name="attributes[frequency]"]:checked, select[name="attributes[frequency]"]');
    const freq = MS.normaliseFrequency(freqInput ? freqInput.value : 'every_week');
    const configuredTarget = (newDiet === 'Vegan') ? cartConfig.veganVariantId : cartConfig.vegVariantId;
    const fallbackTarget = (newDiet === 'Vegan') ? MS.config.tiffin.variants.Vegan : MS.config.tiffin.variants.Vegetarian;
    const targetVariantId = configuredTarget || fallbackTarget;
    const planId = MS.planForTiffin(freq);

    if (statusEl) statusEl.textContent = 'Updating your tiffin to ' + newDiet + '…';

    MS.addSubscriptionLine({
      variantId: targetVariantId,
      handle: MS.config.tiffin.handle,
      productId: MS.config.tiffin.productId,
      planId: planId,
      frequency: freq,
      quantity: currentQty,
      properties: {
        _role: 'tiffin',
        _diet: newDiet
      }
    }).then(function () {
      return MS.cartChange({ id: itemKey, quantity: 0 });
    }).then(function () {
      return MS.cartUpdate(collectAttributes());
    }).then(function () {
      window.location.reload();
    }).catch(function (err) {
      console.error('[Majahma] Diet swap failed:', err);
      if (statusEl) {
        statusEl.textContent = MS.parseError(err, 'Could not switch diet. Please reload and try again.');
      }
    });
  }

  function findTiffinItem() {
    return document.querySelector('.majahma-cart__item[data-is-tiffin="true"]');
  }

  // ─── FREQUENCY → SYNC ALL SUBSCRIPTION LINES ───────────────────────────
  function handleFrequencyChange(e) {
    const MS = window.MajahmaSubscriptions;
    const newFreq = e.target.value;
    const statusEl = document.getElementById('freq-status');
    autoSaveCartAttributes();
    updateSummaryFreq(newFreq);

    if (!MS) {
      if (statusEl) statusEl.textContent = 'Saved, but could not sync selling plans. Please refresh and try again.';
      return;
    }

    if (statusEl) statusEl.textContent = 'Syncing your tiffin and sides to ' + freqLabel(newFreq) + '…';

    const lines = Array.from(document.querySelectorAll('.majahma-cart__item'));
    if (lines.length === 0) return;

    syncLinesSequentially(lines, MS.normaliseFrequency(newFreq), 0, [])
      .then(function (failures) {
        return MS.cartUpdate(collectAttributes()).then(function () { return failures; });
      })
      .then(function (failures) {
        if (failures && failures.length) {
          console.warn('[Majahma] Some lines could not be synced:', failures);
          if (statusEl) statusEl.textContent = 'Frequency saved. One item may need removing/re-adding if it did not update.';
          setTimeout(function () { window.location.reload(); }, 900);
        } else {
          window.location.reload();
        }
      })
      .catch(function (err) {
        console.error('[Majahma] Frequency sync failed:', err);
        if (statusEl) statusEl.textContent = 'Frequency saved, but the cart could not be refreshed. Please reload and check your items.';
      });
  }

  function syncLinesSequentially(lines, freq, idx, failures) {
    const MS = window.MajahmaSubscriptions;
    failures = failures || [];
    if (idx >= lines.length) return Promise.resolve(failures);

    const line = lines[idx];
    const handle = line.getAttribute('data-product-handle');
    const productId = line.getAttribute('data-product-id');
    const variantId = line.getAttribute('data-variant-id');
    const itemKey = line.getAttribute('data-key');
    const lineIndex = parseInt(line.getAttribute('data-line-index'), 10);
    const qtyInput = line.querySelector('.majahma-cart__qty-input');
    const quantity = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
    const expectedPlan = MS.planForLine(handle, productId, freq);

    if (!expectedPlan) {
      return syncLinesSequentially(lines, freq, idx + 1, failures);
    }

    return changeLineSellingPlan(lineIndex, quantity, expectedPlan, handle, variantId, freq)
      .catch(function (err) {
        failures.push({ key: itemKey, line: lineIndex, handle: handle, error: err });
      })
      .then(function () {
        return syncLinesSequentially(lines, freq, idx + 1, failures);
      });
  }

  function changeLineSellingPlan(lineIndex, quantity, planId, handle, variantId, freq) {
    const MS = window.MajahmaSubscriptions;
    return MS.cartChange({ line: lineIndex, quantity: quantity, selling_plan: parseInt(planId, 10) })
      .catch(function (err) {
        const message = MS.parseError(err, '').toLowerCase();
        if (!/selling plan|requires a plan|only be purchased/.test(message) && err.status !== 422) throw err;
        return MS.livePlanFor(handle, variantId, freq, planId).then(function (live) {
          if (live.chosen && String(live.chosen.id) !== String(planId)) {
            return MS.cartChange({ line: lineIndex, quantity: quantity, selling_plan: parseInt(live.chosen.id, 10) });
          }
          throw err;
        });
      });
  }

  function pickSellingPlanFor(freq) {
    const MS = window.MajahmaSubscriptions;
    if (MS) return MS.planForTiffin(freq);
    switch (freq) {
      case 'every_week':    return cartConfig.weeklyPlanId;
      case 'every_2_weeks': return cartConfig.fortnightlyPlanId;
      case 'every_4_weeks': return cartConfig.fourWeeklyPlanId;
      default: return null;
    }
  }

  function pickSellingPlanForCurrentFrequency() {
    var checked = document.querySelector('input[name="attributes[frequency]"]:checked, select[name="attributes[frequency]"]');
    if (!checked) return null;
    return pickSellingPlanFor(checked.value);
  }

  // ─── FOOD SENSITIVITIES ──────────────────────────────────────────────────
  function handleSensitivitiesAnswerChange() {
    const yes = document.getElementById('sens-yes');
    const detailsPanel = document.getElementById('sens-details');
    if (!detailsPanel) return;
    if (yes && yes.checked) {
      detailsPanel.style.display = '';
    } else {
      detailsPanel.style.display = 'none';
    }
    autoSaveCartAttributes();
  }

  function collectSelectedAllergens() {
    var inputs = document.querySelectorAll('.majahma-cart__allergen-input:checked');
    var out = [];
    inputs.forEach(function (i) { out.push(i.value); });
    return out;
  }

  // ─── GEOMETRY ────────────────────────────────────────────────────────────
  function pointInPolygon(lon, lat, poly) {
    var inside = false;
    var j = poly.length - 1;
    for (var i = 0; i < poly.length; i++) {
      var xi = poly[i][0], yi = poly[i][1];
      var xj = poly[j][0], yj = poly[j][1];
      if (((yi > lat) !== (yj > lat)) && (lon < (xj - xi) * (lat - yi) / (yj - yi) + xi)) {
        inside = !inside;
      }
      j = i;
    }
    return inside;
  }

  // ─── ZONES FROM THE THEME EDITOR ─────────────────────────────────────────
  // Accepts one ring — [[lon,lat],[lon,lat],…] — or several wrapped in another
  // array. Anything malformed is dropped rather than trusted.
  function normalisePolys(value) {
    if (!Array.isArray(value) || value.length === 0) return [];

    function isRing(candidate) {
      return Array.isArray(candidate) &&
             candidate.length > 2 &&
             Array.isArray(candidate[0]) &&
             typeof candidate[0][0] === 'number' &&
             typeof candidate[0][1] === 'number';
    }

    if (isRing(value)) return [value];
    return value.filter(isRing);
  }

  function loadZonesFromTheme() {
    var nodes = document.querySelectorAll('.majahma-delivery-zone');
    if (!nodes.length) return null;

    var zones = [];
    Array.prototype.forEach.call(nodes, function (node) {
      var label = (node.getAttribute('data-zone-name') || '').trim() || 'Delivery zone';

      var days = [];
      if (node.getAttribute('data-thursday') === 'true') days.push('thursday');
      if (node.getAttribute('data-friday') === 'true') days.push('friday');
      if (!days.length) {
        console.warn('[Majahma] Delivery zone "' + label + '" has no delivery days ticked, so it was skipped.');
        return;
      }

      var parsed;
      try {
        parsed = JSON.parse(node.getAttribute('data-polygons') || '');
      } catch (err) {
        console.error('[Majahma] Delivery zone "' + label + '" has area coordinates that are not valid JSON, so it was skipped.', err);
        return;
      }

      var polys = normalisePolys(parsed);
      if (!polys.length) {
        console.error('[Majahma] Delivery zone "' + label + '" has no usable area coordinates, so it was skipped. Expected [[longitude, latitude], …].');
        return;
      }

      zones.push({ label: label, days: days, polys: polys });
    });

    if (!zones.length) {
      console.warn('[Majahma] No usable delivery zones in the theme settings — falling back to the zones built into majahma-cart.js.');
      return null;
    }
    return zones;
  }

  function lookupCoords(lon, lat) {
    for (var z = 0; z < activeZones.length; z++) {
      var zone = activeZones[z];
      for (var p = 0; p < zone.polys.length; p++) {
        if (pointInPolygon(lon, lat, zone.polys[p])) return zone;
      }
    }
    return null;
  }

  function handlePostcodeCheck() {
    var input = document.getElementById('cart-postcode');
    var resultEl = document.getElementById('postcode-result');
    var checkBtn = document.getElementById('check-postcode-btn');
    if (!input || !resultEl) return;

    var raw = input.value.trim();
    if (!raw) {
      showResult(resultEl, 'Please enter your postcode.', 'error');
      return;
    }

    var cleaned = raw.toUpperCase().replace(/\s+/g, '');
    if (!/^[A-Z]{1,2}[0-9][0-9A-Z]?[0-9][A-Z]{2}$/.test(cleaned)) {
      showResult(resultEl, 'Please enter a valid UK postcode (e.g. BN1 4AB).', 'error');
      return;
    }

    checkBtn.disabled = true;
    checkBtn.textContent = 'Checking…';
    showResult(resultEl, 'Looking up your postcode…', 'loading');

    fetch('https://api.postcodes.io/postcodes/' + encodeURIComponent(cleaned))
      .then(function (r) { return r.json(); })
      .then(function (data) {
        checkBtn.disabled = false;
        checkBtn.textContent = 'Check';

        if (!data.result) {
          showResult(resultEl, '❌ Postcode not found. Please check and try again.', 'error');
          return;
        }

        var zone = lookupCoords(data.result.longitude, data.result.latitude);

        if (!zone) {
          showResult(resultEl,
            'Sorry, we do not deliver to <strong>' + raw.toUpperCase() + '</strong> yet. ' +
            '<a href="/pages/contact" class="majahma-link">Join our waitlist</a> and we\'ll let you know when we expand.',
            'error');
          validatedPostcode = null;
          allowedDays = [];
          currentZoneLabel = null;
          hideElement('calendar-group');
          return;
        }

        validatedPostcode = raw;
        allowedDays = zone.days;
        currentZoneLabel = zone.label;

        var dayLabel = zone.days.length === 2 ? 'Thursday or Friday' : (zone.days[0] === 'thursday' ? 'Thursdays' : 'Fridays');
        showResult(resultEl,
          '✅ Great — we deliver to you on <strong>' + dayLabel + '</strong>.',
          'success');

        // Show the calendar; the day is now derived from the picked date.
        showDeliveryStep(zone.days);
        autoSaveCartAttributes();

        var savedDate = document.getElementById('cart-delivery-date');
        if (savedDate && savedDate.value) {
          selectedDate = savedDate.value;
          highlightSelectedDate(savedDate.value);
          updateSelectedDateDisplay(savedDate.value);
        }
      })
      .catch(function () {
        checkBtn.disabled = false;
        checkBtn.textContent = 'Check';
        showResult(resultEl,
          'Could not check your postcode right now. Please try again or <a href="/pages/contact" class="majahma-link">contact us</a>.',
          'error');
      });
  }

  function showDeliveryStep(days) {
    var calGroup = document.getElementById('calendar-group');
    if (!calGroup) return;
    var hintEl = document.getElementById('calendar-hint');
    if (hintEl) {
      var dayLabel = days.length === 2 ? 'Thursday or Friday' : (days[0] === 'thursday' ? 'Thursdays' : 'Fridays');
      hintEl.textContent = 'Available delivery days for your area: ' + dayLabel + '. Cut-off for this week\'s delivery is Tuesday at 6pm.';
    }
    renderCalendar(days);
    // Make calendar group visible (removes the --hidden modifier)
    calGroup.classList.remove('majahma-cart__date-group--hidden');
    calGroup.classList.add('majahma-cart__date-group--visible');
  }

  // ─── CALENDAR ────────────────────────────────────────────────────────────
  let calendarViewYear = null;
  let calendarViewMonth = null;

  function renderCalendar(zone) {
    const container = document.getElementById('majahma-calendar');
    if (!container) return;

    // No separate day chooser any more — calendar always shows all valid days
    // for the zone (Thursdays, Fridays, or both depending on postcode).
    var effectiveZone = zone.slice();

    const validDates = getValidDates(effectiveZone);
    if (validDates.length === 0) {
      container.innerHTML = '<p class="majahma-cart__field-hint">No available dates found. Please contact us.</p>';
      return;
    }

    if (calendarViewYear === null || calendarViewMonth === null) {
      const firstValid = validDates[0].date;
      calendarViewYear = firstValid.getFullYear();
      calendarViewMonth = firstValid.getMonth();
    }

    drawMonth(container, validDates, effectiveZone);
  }

  function drawMonth(container, validDates, effectiveZone) {
    container.innerHTML = '';
    container.className = 'majahma-calendar majahma-calendar--month';

    const validMap = {};
    validDates.forEach(function (info) { validMap[isoDate(info.date)] = info; });

    const firstValidDate = validDates[0].date;
    const lastValidDate = validDates[validDates.length - 1].date;
    const firstValidMonth = firstValidDate.getFullYear() * 12 + firstValidDate.getMonth();
    const lastValidMonth = lastValidDate.getFullYear() * 12 + lastValidDate.getMonth();
    const currentMonth = calendarViewYear * 12 + calendarViewMonth;

    const canGoBack = currentMonth > firstValidMonth;
    const canGoFwd = currentMonth < lastValidMonth;

    const header = document.createElement('div');
    header.className = 'majahma-calendar__header';

    const prevBtn = document.createElement('button');
    prevBtn.type = 'button';
    prevBtn.className = 'majahma-calendar__nav';
    prevBtn.setAttribute('aria-label', 'Previous month');
    prevBtn.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg>';
    prevBtn.disabled = !canGoBack;
    prevBtn.addEventListener('click', function () {
      if (!canGoBack) return;
      calendarViewMonth--;
      if (calendarViewMonth < 0) { calendarViewMonth = 11; calendarViewYear--; }
      drawMonth(container, validDates, effectiveZone);
    });

    const title = document.createElement('div');
    title.className = 'majahma-calendar__title';
    const monthNames = ['January','February','March','April','May','June','July','August','September','October','November','December'];
    title.textContent = monthNames[calendarViewMonth] + ' ' + calendarViewYear;

    const nextBtn = document.createElement('button');
    nextBtn.type = 'button';
    nextBtn.className = 'majahma-calendar__nav';
    nextBtn.setAttribute('aria-label', 'Next month');
    nextBtn.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>';
    nextBtn.disabled = !canGoFwd;
    nextBtn.addEventListener('click', function () {
      if (!canGoFwd) return;
      calendarViewMonth++;
      if (calendarViewMonth > 11) { calendarViewMonth = 0; calendarViewYear++; }
      drawMonth(container, validDates, effectiveZone);
    });

    header.appendChild(prevBtn);
    header.appendChild(title);
    header.appendChild(nextBtn);
    container.appendChild(header);

    const dowRow = document.createElement('div');
    dowRow.className = 'majahma-calendar__dow';
    ['Mon','Tue','Wed','Thu','Fri','Sat','Sun'].forEach(function (lbl) {
      const cell = document.createElement('div');
      cell.className = 'majahma-calendar__dow-cell';
      cell.textContent = lbl;
      dowRow.appendChild(cell);
    });
    container.appendChild(dowRow);

    const grid = document.createElement('div');
    grid.className = 'majahma-calendar__grid';

    const firstOfMonth = new Date(calendarViewYear, calendarViewMonth, 1);
    let startOffset = firstOfMonth.getDay() - 1;
    if (startOffset < 0) startOffset = 6;

    const daysInMonth = new Date(calendarViewYear, calendarViewMonth + 1, 0).getDate();

    // The month used to be offset with empty spacer <div>s, but Dawn's base.css
    // carries a global `div:empty { display: none }` rule, which removed them
    // and shifted every date one column left for each day of offset — so the
    // grid only looked right in months starting on a Monday. Offsetting the
    // first day with grid-column-start needs no empty elements at all.

    for (let dayNum = 1; dayNum <= daysInMonth; dayNum++) {
      const d = new Date(calendarViewYear, calendarViewMonth, dayNum);
      const iso = isoDate(d);
      const valid = validMap[iso];
      const isSelectable = valid && !valid.disabled;
      const isBlackout = valid && valid.blackout;
      const label = formatDate(d);

      const cell = document.createElement('button');
      cell.type = 'button';
      cell.className = 'majahma-calendar__cell';
      cell.textContent = dayNum;
      cell.setAttribute('data-date', label);

      if (dayNum === 1 && startOffset > 0) {
        cell.style.gridColumnStart = String(startOffset + 1);
      }

      if (isSelectable) {
        cell.classList.add('majahma-calendar__cell--available');
        cell.setAttribute('aria-label', label);
        cell.addEventListener('click', function () {
          selectDate(label);
          grid.querySelectorAll('.majahma-calendar__cell--selected').forEach(function (el) {
            el.classList.remove('majahma-calendar__cell--selected');
            el.setAttribute('aria-pressed', 'false');
          });
          cell.classList.add('majahma-calendar__cell--selected');
          cell.setAttribute('aria-pressed', 'true');
        });

        if (selectedDate === label) {
          cell.classList.add('majahma-calendar__cell--selected');
          cell.setAttribute('aria-pressed', 'true');
        }
      } else {
        cell.classList.add('majahma-calendar__cell--disabled');
        cell.disabled = true;
        if (isBlackout) {
          cell.classList.add('majahma-calendar__cell--blackout');
          cell.setAttribute('title', 'Closed for delivery');
        }
        cell.setAttribute('aria-label', label + ' (not available)');
      }

      grid.appendChild(cell);
    }

    container.appendChild(grid);

    if (!selectedDate && validDates.length > 0) {
      const firstAvailable = validDates.find(function (info) { return !info.disabled; });
      if (firstAvailable) {
        const lbl = formatDate(firstAvailable.date);
        selectDate(lbl);
        const cell = grid.querySelector('[data-date="' + lbl + '"]');
        if (cell) {
          cell.classList.add('majahma-calendar__cell--selected');
          cell.setAttribute('aria-pressed', 'true');
        }
      }
    }
  }

  function getValidDates(zone) {
    const now = new Date();
    const result = [];

    const dow = now.getDay();
    const hour = now.getHours();
    let earliest = new Date(now);
    earliest.setHours(0, 0, 0, 0);

    if (dow > CUTOFF_DAY || (dow === CUTOFF_DAY && hour >= CUTOFF_HOUR) || dow === 0) {
      while (earliest.getDay() !== THURSDAY) {
        earliest.setDate(earliest.getDate() + 1);
      }
    }

    const end = new Date(earliest);
    end.setDate(end.getDate() + WEEKS_AHEAD * 7);

    for (let d = new Date(earliest); d <= end; d.setDate(d.getDate() + 1)) {
      const day = d.getDay();
      const isThursday = (day === THURSDAY);
      const isFriday   = (day === FRIDAY);

      if (!isThursday && !isFriday) continue;
      if (isThursday && zone.indexOf('thursday') === -1) continue;
      if (isFriday   && zone.indexOf('friday')   === -1) continue;

      const iso = isoDate(d);
      const isBlackout = BLACKOUT_DATES.indexOf(iso) !== -1;
      result.push({ date: new Date(d), disabled: isBlackout, blackout: isBlackout });
    }

    return result;
  }

  function isoDate(d) {
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return y + '-' + m + '-' + day;
  }

  function selectDate(label) {
    selectedDate = label;
    const hiddenInput = document.getElementById('cart-delivery-date');
    if (hiddenInput) hiddenInput.value = label;

    // Derive day-of-week from the label (e.g. "Thursday 19 Jun 2026" → "Thursday")
    var dayName = '';
    if (label) {
      var firstWord = label.split(' ')[0];
      if (firstWord === 'Thursday' || firstWord === 'Friday') dayName = firstWord;
    }

    // Sync the hidden delivery_day radio so the cart attribute saves correctly
    var thuRadio = document.getElementById('hidden-day-thu');
    var friRadio = document.getElementById('hidden-day-fri');
    if (thuRadio) thuRadio.checked = (dayName === 'Thursday');
    if (friRadio) friRadio.checked = (dayName === 'Friday');

    // Update the order card line live
    updateOrderCardDayLine(dayName);

    updateSelectedDateDisplay(label);
    autoSaveCartAttributes();
  }

  function updateOrderCardDayLine(dayName) {
    var lineEl = document.getElementById('order-card-day-line');
    if (!lineEl) return;
    if (dayName) {
      var prefix = lineEl.getAttribute('data-prefix') || 'On a';
      lineEl.innerHTML = prefix + ' <strong id="order-card-day-name">' + dayName + '</strong>';
      lineEl.classList.remove('majahma-cart__order-day--empty');
    }
  }

  function updateSelectedDateDisplay(label) {
    rebuildSummaryDelivery(label);
  }

  function rebuildSummaryDelivery(dateLabel) {
    // Summary now only shows totals + the date label appears in the date trigger,
    // so this is effectively a no-op for visible content. Kept as a hook in case
    // we want to re-introduce a delivery summary row.
  }

  function formatMoney(pence) {
    var pounds = (pence / 100).toFixed(2);
    return '£' + pounds;
  }

  function freqLabel(val) {
    const labels = {
      every_week:    'Weekly',
      every_2_weeks: 'Fortnightly',
      every_4_weeks: '4 Weekly'
    };
    return labels[val] || val;
  }

  function updateSummaryFreq(val) {
    rebuildSummaryDelivery(selectedDate);
  }

  // ─── CHECKOUT VALIDATION ────────────────────────────────────────────────
  window.majahmaCartValidateAndCheckout = function () {
    const errors = [];

    if (!findTiffinItem()) {
      errors.push('Please add the Majahma Dinner subscription to your cart.');
    }

    const diet = document.querySelector('input[name="attributes[diet_preference]"]:checked, select[name="attributes[diet_preference]"]');
    if (!diet || !diet.value) {
      errors.push('Please choose Vegetarian or Vegan.');
    }

    const freq = document.querySelector('input[name="attributes[frequency]"]:checked, select[name="attributes[frequency]"]');
    if (!freq || !freq.value) {
      errors.push('Please choose how often you\'d like your tiffin.');
    }

    const items = document.querySelectorAll('.majahma-cart__item');
    const MS = window.MajahmaSubscriptions;
    if (MS && freq) {
      let mismatch = false;
      items.forEach(function (it) {
        const handle = it.getAttribute('data-product-handle');
        const productId = it.getAttribute('data-product-id');
        const currentPlan = it.getAttribute('data-current-selling-plan') || '';
        const currentPlanName = it.getAttribute('data-current-selling-plan-name') || ((it.querySelector('.majahma-cart__item-plan') || {}).textContent || '');
        const expectedPlan = MS.normalisePlanId ? MS.normalisePlanId(MS.planForLine(handle, productId, freq.value)) : MS.planForLine(handle, productId, freq.value);
        const planNameMatches = MS.planMatchesFrequency ? MS.planMatchesFrequency({ name: currentPlanName }, freq.value) : false;
        if (expectedPlan && String(currentPlan) !== String(expectedPlan) && !planNameMatches) mismatch = true;
      });
      if (mismatch) {
        errors.push('One or more subscription items still need syncing to ' + freqLabel(freq.value) + '. Re-select the frequency above, or remove and re-add the affected side.');
      }
    }

    if (!validatedPostcode) {
      errors.push('Please enter and check your postcode.');
    }

    const deliveryDate = document.getElementById('cart-delivery-date');
    if (!deliveryDate || !deliveryDate.value) {
      errors.push('Please choose your first delivery date.');
    }

    const sensAnswer = document.querySelector('input[name="attributes[food_sensitivities_answer]"]:checked');
    if (!sensAnswer) {
      errors.push('Please tell us whether you have any food sensitivities or allergens.');
    } else if (sensAnswer.value === 'Yes') {
      // The Yes panel now holds the Vegan tick as well as the allergen list, so
      // ticking Vegan on its own is a complete answer — a vegan with no allergies
      // must not be blocked from checking out.
      const allergens = collectSelectedAllergens();
      const details = (document.getElementById('cart-sens-details') || {}).value || '';
      const veganBox = document.getElementById('cart-vegan-checkbox');
      const veganChosen = !!(veganBox && veganBox.checked);
      if (allergens.length === 0 && details.trim() === '' && !veganChosen) {
        errors.push('Please tell us what to look out for — tick Vegan, tick any allergens, or add a note.');
      }
    }

    const termsCheckbox = document.getElementById('cart-terms');
    if (termsCheckbox && !termsCheckbox.checked) {
      errors.push('Please agree to the terms and conditions.');
    }

    const msgEl = document.getElementById('checkout-validation-msg');

    if (errors.length > 0) {
      if (msgEl) msgEl.innerHTML = '<ul>' + errors.map(function (e) { return '<li>' + e + '</li>'; }).join('') + '</ul>';
      const firstError = document.querySelector('.majahma-cart__field-group:not([style*="none"])') || document.querySelector('.majahma-cart__section');
      if (firstError) firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }

    if (msgEl) msgEl.innerHTML = '';
    saveCartAttributesThenCheckout();
  };

  // ─── CART ATTRIBUTE PERSISTENCE ─────────────────────────────────────────
  function autoSaveCartAttributes() {
    updateCartMeta(collectAttributes()).catch(function () {});
  }

  function saveCartAttributesThenCheckout() {
    updateCartMeta(collectAttributes()).then(function () {
      window.location.href = '/checkout';
    }).catch(function () {
      window.location.href = '/checkout';
    });
  }

  function updateCartMeta(attrs) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(buildCartUpdatePayload(attrs))
    });
  }

  function buildCartUpdatePayload(attrs) {
    return { attributes: attrs || {}, note: buildOrderNote() };
  }

  function buildOrderNote() {
    const instructionsEl = document.getElementById('cart-delivery-instructions');
    const w3wEl = document.getElementById('cart-w3w');
    const instructions = instructionsEl ? instructionsEl.value.trim() : '';
    const w3w = w3wEl ? w3wEl.value.trim() : '';
    const lines = [];
    if (instructions) lines.push(instructions);
    if (w3w) lines.push(w3w);
    return lines.join('\n');
  }

  function collectAttributes() {
    const attrs = {};
    var v;

    v = document.getElementById('cart-postcode');
    if (v) attrs['delivery_postcode'] = v.value.trim();

    if (currentZoneLabel) {
      attrs['delivery_zone'] = currentZoneLabel;
    }

    // Delivery surcharges are paused. Written blank rather than omitted so a
    // cart that still carries a value from before the pause is cleared.
    attrs['delivery_surcharge_pence'] = '';

    // The weekday of the FIRST delivery. Written twice: `delivery_day` for the
    // cart's own use, and `Delivery-Day` in the hyphenated capitalised style
    // LionWheel's other fields use. LionWheel's route import currently reads
    // the day off the product variant name, which the old tiffin product
    // carried (VEGGIE / Thursday) and the new one does not. Writing the key
    // here means the field already exists on orders if LionWheel can be
    // pointed at it — nothing downstream has to wait on a code change.
    v = document.querySelector('input[name="attributes[delivery_day]"]:checked');
    if (v) {
      attrs['Delivery-Day'] = v.value;
      // Snake_case twin retired — the cart page now restores the day from
      // `Delivery-Day`. Written blank so any cart saved before this change
      // drops it rather than carrying it onto the order.
      attrs['delivery_day'] = '';
    }

    v = document.getElementById('cart-delivery-date');
    if (v) {
      attrs['delivery_date'] = v.value;
      // LionWheel reads an attribute called `Delivery-Date` in YYYY/MM/DD.
      var lwDate = lionwheelDate(v.value);
      if (lwDate) attrs['Delivery-Date'] = lwDate;
    }

    // The two fixed LionWheel fields — see the constants at the top of this file.
    attrs['Delivery-Location-Id'] = LIONWHEEL_LOCATION_ID;
    attrs['Checkout-Method'] = LIONWHEEL_CHECKOUT_METHOD;

    v = document.querySelector('input[name="attributes[diet_preference]"]:checked, select[name="attributes[diet_preference]"]');
    if (v) attrs['diet_preference'] = v.value;

    v = document.querySelector('input[name="attributes[frequency]"]:checked, select[name="attributes[frequency]"]');
    if (v) attrs['frequency'] = v.value;

    // Delivery instructions go to three keys. `Delivery-Note` is the one
    // LionWheel reads. `delivery_instructions` used to be hard-coded blank,
    // which forced the cart page to recover the text by splitting the order
    // note on newlines — that mangled any instruction containing a line break.
    // Writing the real value here means the note is only a convenience copy.
    v = document.getElementById('cart-delivery-instructions');
    var deliveryNote = v ? v.value.trim() : '';
    attrs['Delivery-Note'] = deliveryNote;
    attrs['delivery_instructions'] = '';

    // Legacy orders carry what3words under the key `what3words address`.
    v = document.getElementById('cart-w3w');
    var w3wValue = v ? v.value.trim() : '';
    attrs['what3words address'] = w3wValue;
    attrs['what3words'] = '';

    // ─── ALLERGENS ─────────────────────────────────────────────────────────
    // Two schemas again. The kitchen reads the legacy keys (`Allergies`,
    // `Other allergies`, plus one self-named key per ticked allergen, e.g.
    // `Gluten` = "Gluten"), so every one of them is written alongside the new
    // snake_case keys.
    //
    // The legacy form used shorter allergen names than the FSA-14 list on the
    // cart page. Only the two seen on real orders are mapped below. If the
    // kitchen sheet looks for any other short name, add it here — the key on
    // the left is the cart-page label, the value on the right is the name that
    // goes on the order.
    var LEGACY_ALLERGEN_NAME = {
      'Cereals containing gluten': 'Gluten',
      'Soybeans': 'Soya'
    };

    // Every possible allergen key is blanked first, then the ticked ones are
    // filled in. Shopify drops an attribute written as an empty string, so an
    // allergen the customer ticks and then unticks disappears from the order
    // instead of sticking around from the earlier autosave.
    var ALL_ALLERGENS = [
      'Celery', 'Cereals containing gluten', 'Crustaceans', 'Eggs', 'Fish',
      'Lupin', 'Milk', 'Molluscs', 'Mustard', 'Tree nuts', 'Peanuts',
      'Sesame', 'Soybeans', 'Sulphur dioxide and sulphites'
    ];
    ALL_ALLERGENS.forEach(function (name) {
      attrs[LEGACY_ALLERGEN_NAME[name] || name] = '';
    });

    var sensAnswer = document.querySelector('input[name="attributes[food_sensitivities_answer]"]:checked');
    if (sensAnswer) {
      attrs['food_sensitivities_answer'] = sensAnswer.value;
      if (sensAnswer.value === 'Yes') {
        var sel = collectSelectedAllergens();
        var legacyNames = sel.map(function (name) {
          return LEGACY_ALLERGEN_NAME[name] || name;
        });
        attrs['food_sensitivity_allergens'] = sel.join(', ');
        attrs['Allergies'] = legacyNames.join(', ');

        var det = document.getElementById('cart-sens-details');
        var detText = det ? det.value.trim() : '';
        attrs['Other allergies'] = detText;
        attrs['food_sensitivities_details'] = '';
      } else {
        attrs['food_sensitivity_allergens'] = '';
        attrs['food_sensitivities_details'] = '';
        attrs['Allergies'] = '';
        attrs['Other allergies'] = '';
      }
    }

    // Terms go to three keys — `terms_accepted` for the new cart, and the two
    // the legacy checkout wrote, both carrying the literal string "18+ Yes".
    var termsCheck = document.getElementById('cart-terms');
    if (termsCheck && termsCheck.checked) {
      attrs['Agreed to Terms'] = '18+ Yes';
      attrs['18+ Yes'] = '18+ Yes';
      attrs['terms_accepted'] = '';
    } else {
      attrs['Agreed to Terms'] = '';
      attrs['18+ Yes'] = '';
      attrs['terms_accepted'] = '';
    }

    return attrs;
  }

  // ─── QTY / REMOVE LINE ──────────────────────────────────────────────────
  function handleQtyChange(e) {
    const btn    = e.currentTarget;
    const action = btn.dataset.action;
    const key    = btn.dataset.key;
    const input  = document.querySelector('input[data-key="' + key + '"]');
    if (!input) return;

    let qty = parseInt(input.value, 10) || 1;
    qty = action === 'increase' ? qty + 1 : Math.max(0, qty - 1);
    input.value = qty;
    updateCartItem(key, qty);
  }

  function handleRemove(e) {
    const key = e.currentTarget.dataset.key;
    updateCartItem(key, 0);
  }

  function updateCartItem(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) { return r.json(); })
      .then(function () { window.location.reload(); })
      .catch(function () { window.location.reload(); });
  }

  // ─── HELPERS ─────────────────────────────────────────────────────────────
  function showElement(id) {
    const el = document.getElementById(id);
    if (el) el.style.display = '';
  }

  function hideElement(id) {
    const el = document.getElementById(id);
    if (el) el.style.display = 'none';
  }

  function showResult(el, html, type) {
    el.innerHTML = html;
    el.className = 'majahma-cart__postcode-result majahma-cart__postcode-result--' + type;
  }

  function highlightSelectedDate(label) {
    const buttons = document.querySelectorAll('.majahma-calendar__cell');
    buttons.forEach(function (btn) {
      if (btn.dataset.date === label) btn.classList.add('majahma-calendar__cell--selected');
    });
  }

  function formatDate(d) {
    const days   = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
    const months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    return days[d.getDay()] + ' ' + d.getDate() + ' ' + months[d.getMonth()] + ' ' + d.getFullYear();
  }

  // LionWheel expects an order attribute named `Delivery-Date`, formatted
  // YYYY/MM/DD (e.g. 2026/09/18). The hidden input carries the human label
  // ("Friday 18 Sep 2026"), so parse that rather than tracking a second value —
  // this works whether the date was just picked, auto-selected, or restored
  // from a saved cart on page load.
  function lionwheelDate(label) {
    if (!label) return '';
    var m = String(label).match(/(\d{1,2})\s+([A-Za-z]{3})[a-z]*\s+(\d{4})/);
    if (!m) return '';
    var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    var mi = months.indexOf(m[2].slice(0, 3));
    if (mi === -1) return '';
    return m[3] + '/' + ('0' + (mi + 1)).slice(-2) + '/' + ('0' + m[1]).slice(-2);
  }
})();
